import { Input } from 'antd';
import React, { useEffect, useRef } from 'react';

const CustomTextArea = ({
  placeholder,
  defaultValue,
  className = '',
  children = null,
  onChange = null,
}) => {
  return (
    <>
      <Input.TextArea
        name="text"
        rows={3}
        style={{
          resize: 'none',
          borderColor: '#e0e0e0 !important',
          minHeight: '90px !important',
        }}
        placeholder={placeholder}
        className={`custom-text-area my-1 p-2 text-justify border-bottom-0 ${className}`}
        onChange={(e) => onChange(e)}
        defaultValue={defaultValue}
      />
      <div className="p-2 text-justify border-bottom border-left border-right">
        {children}
      </div>
    </>
  );
};

export const CustomDiscussionTextArea = ({
  placeholder,
  defaultValue,
  className = '',
  children = null,
  onChange = null,
  visible,
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (visible) {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }
  }, [visible]);

  return (
    <>
      <textarea
        name="text"
        rows={3}
        style={{
          resize: 'none',
          borderColor: '#e0e0e0 !important',
          minHeight: '90px !important',
          fontSize: '16px',
          fontWeight: '500',
        }}
        placeholder={placeholder}
        className={`custom-text-area input-hover-border font-bold-placeholder w-100 border-0 text-justify ${className}`}
        onChange={(e) => onChange(e)}
        defaultValue={defaultValue}
        ref={textareaRef}
        autoFocus={true}
      />
      <div className="p-2 text-justify">{children}</div>
    </>
  );
};

export default CustomTextArea;
